<script setup lang="ts">
import { computed, ref } from 'vue'
import sfx from '../../assets/audios/quiz_button_click.mp3'
import { audioManager } from '../../utils/audioManager'

interface Props {
    type?: string
    color?: 'default' | 'primary' | 'secondary' | 'success' | 'info' | 'danger' | 'warning'
    size?: string
    animation?: boolean
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    type: 'default',
    color: 'default',
    size: 'default',
    animation: false,
    disabled: false
})
const buttonClass = ref<string>('transistion-all duration-200 ease-in-out relative border-2 text-base first-letter:capitalize font-bold shadow-[0_4px_0] mb-1 rounded-lg overflow-hidden disabled:opacity-30')
const animationClass = ref<string>(' active:shadow-none active:translate-y-[5px] ')
const buttonTypeClass = computed(() => {
    switch (props.type) {
        case 'icon':
            return 'ratio-square p-1'
        default:
            return ''
    }
})

const buttonColorClass = computed(() => {
    switch (props.color) {
        case 'primary':
            return ' bg-orange-500 dark:bg-red-400 text-white dark:text-zinc-700 border-orange-700 dark:border-red-600 shadow-orange-700 dark:shadow-red-600'
        case 'secondary':
            return ' bg-secondary text-white border-secondary-500 shadow-secondary-500'
        case 'warning':
            return ' bg-warning text-white border-warning-500 shadow-warning-500'
        case 'danger':
            return ' bg-rose-600 dark:bg-yellow-300 text-white dark:text-zinc-700 border-rose-800 dark:border-yellow-600 shadow-rose-800 dark:shadow-yellow-600'
        case 'success':
            return 'bg-green-600 dark:bg-lime-300 text-white dark:text-zinc-700 border-green-700 dark:border-lime-500 shadow-green-700 dark:shadow-lime-500'
        case 'info':
            return ' bg-info text-white border-info-500 shadow-info-500'
        default:
            return 'bg-default text-black border-neutral-300 shadow-neutral-300'
    }
})
const buttonSizeClass = computed(() => {
    switch (props.size) {
        case 'xs':
            return ' text-xs py-1 px-2'
        case 'sm':
            return 'text-sm py-1 px-2'
        case 'lg':
            return 'text-sm py-2 px-3'
        case 'xl':
            return 'text-sm py-2.5 px-3.5'
        default:
            return 'text-sm py-1.5 px-2.5'
    }
})

const playSfx = () => {
    audioManager.stop('button')
    audioManager.play(sfx,'button', { volume: 0.5, loop: false, })
}
</script>
<template>
    <button class="group"
        :class="[buttonClass, { [animationClass]: animation && !disabled, [buttonSizeClass]: props.type != 'icon' }, , buttonColorClass, buttonTypeClass]"
        :disabled="disabled" @mousedown="playSfx()">
        <div
            class="absolute w-full h-2/3 top-1/3 left-0 pointer-events-none transistion-all duration-200 ease-in-out group-hover:top-full bg-black/10 rounded-t-[50%]">
        </div>
        <span class="relative">
            <slot></slot>
        </span>
    </button>
</template>